import { useEffect } from 'react';
import { useDeviceInfo, useDispatch, useLogger, useSelector } from '~Hooks';

import { MethodProps } from '../types';
import { useStorage } from '~/Components/Storage';
import _ from 'lodash';

const IZettlePayment: React.FunctionComponent<MethodProps> = ({
  payment,
  discount,
  order,
  orderAmount,
  amount,
  onMetaChange,
  onComplete,
  onFail,
}) => {
  const logger = useLogger('zettle');
  const [storage] = useStorage();
  const dispatch = useDispatch();
  const request = useSelector((state) =>
    state.paymentBridgeRequests.find((req) => req.paymentId === payment.id),
  );
  const deviceInfo = useDeviceInfo();

  /*
   * This effect sends off the initial payment request
   */
  useEffect(() => {
    // Dont try to make a payment if its not valid
    if (!amount || amount < 10) {
      return;
    }

    logger.info(
      'Zettle: Initiating payment. Amount: ' +
        amount +
        ' Order total: ' +
        (orderAmount - discount).toString(),
      order,
    );

    dispatch({
      type: 'PAYMENT_BRIDGE_REQUEST',
      id: payment.id,
      amount: amount!,
      enableTipping: storage.enableTipping,
      method: 'IZETTLE',
    });
  }, []);

  /*
   * This effect manages payment status after it has been initiated
   */
  useEffect(() => {
    if (amount === 0) {
      onComplete();
    }

    if (!request) {
      return;
    }

    if (request.status === 'SUCCESS') {
      logger.info('Zettle: Payment successful');

      // If we have tips, and it's not a zettle terminal, we need to convert it to cents
      // If it's a zettle terminal, we don't need to convert it.
      const tips = request.tips
        ? deviceInfo?.isHandheldTerminal && deviceInfo?.isZettleTerminal
          ? parseFloat((request.tips as unknown) as string)
          : request.tips * 100
        : 0;

      logger.info('Zettle Tips: ' + tips);

      onMetaChange({
        tip: tips,
      });

      onComplete(null, {
        tip: tips,
        cardDetails: request.cardDetails,
      });
    }

    if (request.error) {
      onFail(request.error);
    }
  }, [request]);

  return null;
};

export default IZettlePayment;
